module.exports = __webpack_public_path__ + "img/tab-tool-add.5859a876.svg";